/* eslint-disable react-doctor/heading-has-content, react-doctor/no-multi-comp */
import { cn } from "@wags/ui/ui-utils";
import { MobileReviewCarousel } from "@/components/shared/MobileReviewCarousel";
import { ReviewCard } from "@/components/shared/ReviewCard";

export type Review = {
    id: string | number;
    author: string;
    timeAgo: string;
    text: string;
    dogName: string;
    photoUrl?: string | null;

    rating?: number | null;
};

export const adoptionLabel = (r: Review) =>
    r.dogName && r.dogName !== "a puppy" ? `Adopted ${r.dogName}` : "";

export function ReviewsSection({
    className,
    ...props
}: React.ComponentProps<"div">) {
    return (
        <div
            data-slot="reviews-section"
            className={cn("flex flex-col", className)}
            {...props}
        />
    );
}

export function ReviewsHeading({
    className,
    ...props
}: React.ComponentProps<"h2">) {
    return (
        <h2
            data-slot="reviews-heading"
            className={cn(
                "text-section-title text-doberman-black text-pretty",
                className,
            )}
            {...props}
        />
    );
}

export function ReviewsGrid({
    reviews,
    contextLabel,
    elevated = false,
    scrollRef,
    scrollRestorationId,
    className,
    ...props
}: {
    reviews: Review[];
    contextLabel: (review: Review) => string;
    elevated?: boolean;
    scrollRef?: React.RefObject<HTMLDivElement | null>;
    scrollRestorationId?: string;
} & Omit<React.ComponentProps<"div">, "children">) {
    return (
        <div data-slot="reviews-grid" className={className} {...props}>
            <div className="mt-6 hidden overflow-hidden md:block -m-2">
                <div
                    ref={scrollRef}
                    data-scroll-restoration-id={scrollRestorationId}
                    className="scroll-fade-x flex gap-4 overflow-x-auto scrollbar-none p-2"
                >
                    {reviews.map((r) => (
                        <div key={r.id} className="w-[320px] shrink-0">
                            <ReviewCard
                                author={r.author}
                                timeAgo={r.timeAgo}
                                text={r.text}
                                context={contextLabel(r)}
                                photoUrl={r.photoUrl}
                                rating={r.rating}
                            />
                        </div>
                    ))}
                </div>
            </div>
            <MobileReviewCarousel
                reviews={reviews}
                contextLabel={contextLabel}
                elevated={elevated}
                scrollRestorationId={
                    scrollRestorationId && `${scrollRestorationId}-mobile`
                }
            />
        </div>
    );
}
